import React, { useEffect, useState } from "react";
import { Tabs, notification, Drawer, Modal, List, Space, Descriptions, Button, Table, DatePicker, Divider, Spin } from "antd";
import { ListUl, Cash, Plus, PencilSquare, ThreeDots, Shop, GeoAltFill } from "react-bootstrap-icons";
import { Row, Col } from "react-bootstrap";
import moment from 'moment';
import ShopIcon from '@iconify-react/flat-color-icons/shop';
import Common from "../components/includes/Common";
import dayjs from 'dayjs';
import ProvisionHistory from "../components/ProvisionHistory";
import AddShop from "../components/forms/AddShop";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var ShowPosDetails = function ShowPosDetails(_ref) {
  var _ref$pos = _ref.pos,
    pos = _ref$pos === void 0 ? null : _ref$pos;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: pos && /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        children: [/*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(Shop, {
            size: 45
          }), /*#__PURE__*/_jsx("h3", {
            children: pos.label
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Descriptions, {
          column: 1,
          items: [{
            key: '1',
            label: 'Téléphone',
            children: pos.mobile
          }, {
            key: '2',
            label: 'E-mail',
            children: pos.email
          }, {
            key: '3',
            label: 'Solde',
            children: pos.balance
          }, {
            key: '4',
            label: 'Gérant(e)',
            children: pos.manager && pos.manager.prenom + " " + pos.manager.nom
          }]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(GeoAltFill, {
            size: 45
          }), /*#__PURE__*/_jsx("h5", {
            children: pos.address
          })]
        }), /*#__PURE__*/_jsx("br", {})]
      })
    })
  });
};
export default ShowPosDetails;